{
	"password": "Mot de passe",
	"confirmPassword": "Confirmation du mot de passe",
	"passwordToggle": {
		"show": "Afficher le mot de passe",
		"hide": "Masquer le mot de passe"
	}
}
